import React, { useLayoutEffect, useMemo } from 'react'
import FieldDebug from './fieldDebug'
import { format, parseISO } from 'date-fns'
import { useSelector } from 'react-redux'
import classNames from 'classnames'

const LastModifiedFieldDetailItem = (props) => {
  const {
    debug = false,
    measure,
    fieldDefinition,
    field,
    hideWhenEmpty = false,
    className = '',
    labelClassName = '',
  } = props

  const { label } = fieldDefinition

  const opportunity = useSelector((state) => state.oppDetail)
  const { lastModifiedDateString } = opportunity

  useLayoutEffect(() => {
    const req = requestAnimationFrame(() => {
      measure && measure()
    })
    return () => {
      req && cancelAnimationFrame(req)
    }
  }, [measure])

  const value = useMemo(() => {
    if (lastModifiedDateString) {
      try {
        const d = parseISO(lastModifiedDateString)
        return format(d, 'M/d/yyyy')
      } catch (err) {
        console.log(err)
      }
    }

    return '-'
  }, [lastModifiedDateString])

  return (
    <>
      {!lastModifiedDateString && hideWhenEmpty
        ? (<></>)
        : (
          <div className={classNames('LastModifiedFieldDetailItem', { 'my-4': !className }, { [className]: className })}>
            <div className={classNames('flex items-center justify-between text-color-09242f text-size-16px font-weight-600 truncate', labelClassName)}>
              {label}
              <FieldDebug
                debug={debug}
                data={{ opportunity, fieldDefinition, field }} />
            </div>
            <div
              style={{ transform: 'translateY(-1px)' }}
              className="text-color-09242f text-size-16px font-weight-300">
              {value}
            </div>
          </div>
        )}
    </>
  )
}

export default LastModifiedFieldDetailItem
